import { render, staticRenderFns } from "./selected-text-menu.vue?vue&type=template&id=cbaf5628"
import script from "./selected-text-menu.vue?vue&type=script&lang=js"
export * from "./selected-text-menu.vue?vue&type=script&lang=js"
import style0 from "./selected-text-menu.vue?vue&type=style&index=0&id=cbaf5628&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports